<template>
  <div class='honur'>

    <img class="title" src="@/assets/goin/hounr/title.png" alt="">

    <div class="honurBg">
      <img class="tit-img" src="@/assets/goin/hounr/desc.png" alt="">
      <div class="desc">
        <div>以环保远见</div>
        <div>连接市场与行业创新技术</div>
        <div>为用户创造健康家居美好生活</div>
      </div>

      <div class="honurBox">
        <div class="honur-item" v-for="(item, index) in honurData" :key="index">
          <img class="itemImg" src="@/assets/goin/hounr/itemImg.png" alt="">
          <img @click="showImg(item.adv_pic[0].url)" class="img" :src="item.adv_pic[0].url" alt="">
          <div class="item-text">{{ item.adv_title }}</div>
        </div>
      </div>

    </div>

    <div class="patent">
      <img class="desc" src="@/assets/goin/hounr/pat-desc.png" alt="">
      <img class="img" src="@/assets/goin/hounr/pat-img.png" alt="">
    </div>

    <div class="bot">
      <img class="desc" src="@/assets/goin/hounr/bot-desc.png" alt="">
      <img class="img" src="@/assets/goin/hounr/bot-img.png" alt="">
    </div>

    <el-dialog
      custom-class="mark"
      :visible.sync="isMark"
      :show-close="false"
      width="30%">
      <img :src="url" alt="">
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
const md5 = require('js-md5')
export default {
  name: 'honur',
  components: {
  },
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 50
      },
      honurData: [],
      isMark: false,
      url: ''
    }
  },
  computed: { },
  watch: {},
  created() {
    const stamp = Date.now()
    axios.get('/api/wxmp/advertise/advertiseGeneral/doAdvertiseGeneralList', {
      params: {
      adv_sign: '3',
      adv_state: '-1',
      adv_type: '-1',
      keyword: '',
      pageNum: this.page.pageNum,
      pageSize: this.page.pageSize,
      stamp,
      sign: md5('3' + '-1' + '-1' + this.page.pageNum + this.page.pageSize + stamp + atob(localStorage.getItem('okey')))
      }
    }).then(res => {
      console.log(res)
      if (res.data.result === 1) {
        this.honurData = res.data.dataList
        for (const item of this.honurData) {
        item.adv_pic = JSON.parse(item.adv_pic)
        }
      }
    })
  },
  mounted() {
  },
  methods: {
    showImg(url) {
      this.url = url
      this.isMark = true
    }
  }
}
</script>
<style lang='less' scoped>
.honur {
  max-width: 1920px;
  margin: 0 auto;
  .title{
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    vertical-align: top;
  }

  .honurBg{
    overflow: hidden;
    background: url('../../../assets/goin/hounr/honurBg.png') no-repeat top;
    background-size: 100% 100%;
    max-width: 1920px;
    margin: 0 auto;
    .tit-img{
      width: 476px;
      height: 45.5px;
      display: block;
      margin: 105px auto 45.5px;
    }
    .desc{
      margin: 0 auto;
      width: 400px;
      height: 120.5px;
      font-size: 30px;
      font-family: FZLanTingHeiS-DB-GB;
      font-weight: 400;
      color: #555555;
      line-height: 46px;
    }

    .honurBox{
      display: flex;
      flex-wrap: wrap;
      margin-top: 89px;
      max-width: 1920px;
      padding: 0 100px 117px;
      justify-content: center;

      .honur-item{
        position: relative;
        width: 322px;
        height: 453px;
        margin-bottom: 50px;
        text-align: center;
        .itemImg{
          width: 300px;
          vertical-align: top;
          box-shadow: -5px 10px 15px 0px rgba(28, 24, 20, 0.18);
        }
        .img{
          position: absolute;
          width: 214px;
          height: 307px;
          object-fit: cover;
          top: 41px;
          left: 50%;
          transform: translateX(-50%);
        }
        .item-text{
          padding: 30px 10px 0 10px;
          text-align: center;
          font-size: 24px;
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          color: #555555;
          line-height: 30px;
        }
      }
    }
  }

  .patent{
    padding-top: 140.5px;
    max-width: 1920px;
    height: 2951.5px;
    background: url('../../../assets/goin/hounr/pat-bg.png') no-repeat;
    background-size: 100%;
    text-align: center;
    img{
      display: block;
    }
    .desc{
      margin: 0 auto;
      width: 667px;
    }
    .img{
      margin: 0 auto;
      margin-top: 100px;
      width: 889.5px;
    }
  }

  .bot{
    padding-top: 95.5px;
    max-width: 1920px;
    height: 1207.5px;
    background: url('../../../assets/goin/hounr/bot-bg.png') no-repeat;
    background-size: cover;
    text-align: center;
    img{
      display: block;
    }
    .desc{
      margin: 0 auto;
      width: 429.5px;
    }
    .img{
      margin: 0 auto;
      margin-top: 39.5px;
      width: 656px;
    }
  }
  /deep/ .el-dialog {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .mark{
    img{
      width: 100%;
      vertical-align: middle;
    }
  }
}
</style>
